import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import useStore from "../store/useStore";
import { useLocation } from "react-router-dom";

export default function CertificacionesCarousel() {
  const apiUrl = process.env.REACT_APP_STRAPI_URL;
  const { certificacion, getCertificacionesAll } = useStore();
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);

  const duplicatedCertificaciones = [...certificacion, ...certificacion];

  useEffect(() => {
    getCertificacionesAll();
  }, [getCertificacionesAll]);

  return (
    <div className="w-full bg-sidom-orange   flex flex-col items-center justify-center">
      <div
        data-aos="fade-up"
        data-aos-delay="700"
        className="container  mt-[100px]"
      >
        <h1 className="font-extrabold  text-left text-3xl md:text-[40px] lg:text-[45px] leading-tight px-2 md:px-0 lg:px-0 text-sidom-light  mb-[60px]">
          Certificaciones
        </h1>
      </div>
      <div className="container">
        <Swiper
          spaceBetween={20}
          slidesPerView={3}
          loop={true}
          speed={7000}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
          breakpoints={{
            0: { slidesPerView: 2 },
            640: { slidesPerView: 3 },
            1024: { slidesPerView: 5 },
          }}
          className="w-full"
        >
          {duplicatedCertificaciones.map((cert, idx) => (
            <SwiperSlide
              key={idx}
              className="flex  items-center mb-[100px] justify-center"
            >
              <img
                data-aos="fade-up"
                data-aos-delay="700"
                src={`${apiUrl}${
                  cert.img?.formats?.thumbnail?.url || cert.img?.url || cert.src
                }`}
                alt={cert.alt}
                className="w-30  md:h-20 grayscale hover:grayscale-0 transition duration-300  mx-auto"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
